import store from '../redux/store';

export const isNotifyProductEnabled = () => {
  const storeData = store.getState().storeReducer.store;
  if (storeData?.services?.notify_me_enabled === 1) {
    return true;
  }
  return false;
};
